import { CheckoutIntents } from 'checkout-intents';

import { Typography } from 'components/ui/typography';

type Props = {
  buyer: CheckoutIntents.Buyer;
};

// Address block — reads like a printed shipping label rather than a
// label/value table with leader dots. Phone hangs below the address as
// a separate, mono-formatted row.
export const ShippingCard = ({ buyer }: Props) => {
  const cityLine = [buyer.city, buyer.province, buyer.postalCode].filter(Boolean).join(', ');
  return (
    <div className="border border-[var(--line)] bg-[var(--surface)] px-4 py-3.5">
      <address className="text-sm not-italic leading-6 text-[var(--text)]">
        <div>
          {buyer.address1}
          {buyer.address2 ? `, ${buyer.address2}` : ''}
        </div>
        {cityLine && <div>{cityLine}</div>}
        {buyer.country && <div>{buyer.country}</div>}
        {buyer.phone && (
          <Typography variant="mono" as="div" className="mt-2 text-[var(--text-muted)]">
            {buyer.phone}
          </Typography>
        )}
      </address>
    </div>
  );
};
